<template>
	<el-row id="login" type="flex" justify="center" align="middle">
		<el-col class="loginBox">
			<el-form ref="userForm" :model="userForm" status-icon label-width="70px" class="demo-ruleForm" :rules="rules">
				<div class="titleIcon"><img src="../pic/titleIcon.png" /></div>
				<div class="title">欢迎来到场馆预订！</div>
				<el-form-item label="用户名" prop="name">
					<el-input v-model="userForm.name" placeholder="请输入用户名"></el-input>
				</el-form-item>
				<p class="fontMes">
					<router-link :to="{path:'/RetrievePassword'}" style="color:#B7A575;text-decoration:none;out-line: none">忘记密码</router-link>
				</p>
				<el-form-item label="密码" prop="pass" style="position: relative;">
					<el-input :type="userForm.showPass?'text':'password'" v-model="userForm.pass" placeholder="请输入密码" maxlength="8"></el-input>
					<i class="el-input__icon el-icon-view el-input__clear" style="" @click="userForm.showPass=!userForm.showPass"></i>
				</el-form-item>
				<el-form-item>
					<el-button style="width: 100%;background: #B7A575;border-color:#B7A575 ;" type="primary" @click="submitForm('userForm')">登录</el-button>
				</el-form-item>
				<p class="fontMes">
					<router-link :to="{path:'/TheRegister'}" style="color:#B7A575;text-decoration:none;out-line: none">还没有注册？快去注册吧</router-link>
				</p>
			</el-form>
		</el-col>
	<FooterMes/>
	</el-row>
</template>
<!--数据存贮交互，事件控制地区-->
<script>
	import FooterMes from "@/components/FooterMes.vue"; // 底部版权说明
	export default {
		name: 'TheLogin',
		components: {
			FooterMes //底部版权说明
		},
		data() {
			return {
				userForm: {
					name: '',
					pass: '',
				},
				//表单验证
				rules: {
					name: {
						required: true,
						message: '请输入用户名！',
						trigger: 'blur'
					},
					//密码验证
					pass: [{
						required: true,
						message: "请输入密码！",
						trigger: 'blur'
					}, {
						min: 6,
						max: 6,
						message: '请输入6位密码！',
						trigger: 'blur'
					}]
				}
			}
		},
		created() {
			this.keyupSubmit();
			let that = this;
			if (sessionStorage.getItem("isLogin") == 'true') {
				const sendData = {
					mobile: sessionStorage.getItem("userMobile"),
					password: sessionStorage.getItem("userpass")
				};
				sessionStorage.setItem("userMobile", sessionStorage.getItem("userMobile"));
				sessionStorage.setItem("userpass", sessionStorage.getItem("password"));
				that.submitFormAJAX(sendData);
			}
		},
		methods: {
			// 登录
			submitForm: function(submitForm) {
				const that = this;
				this.$refs[submitForm].validate((valid) => {
					if (valid) {
						const sendData = {
							mobile: that.userForm.name,
							password: that.userForm.pass
						};
						that.submitFormAJAX(sendData);
					}
				});
			},
			submitFormAJAX: function(sendData) {
				const that = this;
				const sendUrl = this.httpUrl + "HXXCStadiumPCService/stadium/stadiumUserLogin";
				that.axiosPost(sendUrl, sendData).then((res) => {
					const backData = res.data;
					if (backData.state == "0") {
						that.$message({
							message: "登录成功！",
							type: 'success',
							onClose: () => {
								that.$router.push({
									path: '/OrdinaryUsers',
								});
								sessionStorage.setItem("userType", backData.result.userType);
								sessionStorage.setItem("userMobile", that.userForm.name);
								sessionStorage.setItem("userpass", that.userForm.pass);
								sessionStorage.setItem("isLogin", "true");
							}
						});
					} else {
						that.$message({
							message: backData.message,
							type: 'warning'
						});
					}
				})
			},
			keyupSubmit() {
				document.onkeydown = e => {
					let that = this;
					let _key = window.event.keyCode;
					if (_key === 13) {
						const sendData = {
							mobile: that.userForm.name,
							password: that.userForm.pass
						};
						if (sendData.mobile == "") {
							that.$message({
								message: "请输入用户名！",
								type: 'warning'
							});
							return false;
						} else if (sendData.password == "") {
							that.$message({
								message: "请输入密码！",
								type: 'warning'
							});
							return false;
						} else {
							that.submitFormAJAX(sendData);
						}
					}
				}
			},
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	#login {
		width: 100%;
		height: 100%;
		background: url(../pic/loginBg.jpg) no-repeat;
		background-size: 100% 100%;
	}

	.loginBox {
		width: 33%;
		background: #fff;
		max-height: 400px;
		padding: 34px;
		border-radius: 4px;
	}

	.demo-ruleForm {
		width: 100%;
	}

	.el-input__icon {
		position: absolute;
		right: 5px;
		top: 0;
	}

	.fontMes {
		width: 100%;
		text-align: right;
		color: #B7A575;
		font-size: 8px;
		margin-top: -11px;
		margin-bottom: 11px;

	}

	.title {
		color: #000000;
		font-weight: bold;
		font-size: 24px;
		margin-bottom: 29px;
		text-align: center;
	}

	.titleIcon {
		text-align: center;
	}
</style>



// WEBPACK FOOTER //
// src/views/TheLogin.vue